import React, { ReactNode } from "react";
import { Container, Stack } from "@mui/material";

const PageWrapper = ({
  children,
  withBg = true,
}: {
  children: ReactNode;
  withBg?: boolean;
}) => {
  return (
    <Stack
      // sx={{ backgroundColor: "#fff", minHeight: "calc(100vh - 150px)" }}
      sx={[
        (theme) => ({
          // backgroundColor: "#fff",
          minHeight: "calc(100vh - 100px)",
          borderRadius: 2,
        }),
        (theme) =>
          theme.applyStyles("light", {
            backgroundColor: withBg ? "#fff" : "transparent",
          }),
        (theme) =>
          theme.applyStyles("dark", {
            backgroundColor: withBg ? "#111" : "transparent",
          }),
      ]}
    >
      <Container>
        <Stack gap="24px" sx={{ paddingY: "24px" }}>
          {children}
        </Stack>
      </Container>
    </Stack>
  );
};

export default PageWrapper;
